import FlvPlayer, {getVideoSrc as getVideoUrl} from './player';
export * from './playerList';

export default FlvPlayer;
export const getVideoSrc = getVideoUrl;